import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("IdDN", "idDN"),
    ColumnsFactory.TextColumn("DN", "direccionNegocio"),
    ColumnsFactory.TextColumn("Área", "area"),
    ColumnsFactory.TextColumn("Función", "funcion"),
    ColumnsFactory.TextColumn("SubFunción", "subFuncion"),
    ColumnsFactory.NumericColumn("Nº Horas", "nHoras",{ipkTotalizar: true})
  ];
};